// https://stackoverflow.com/questions/4631928/convert-utc-epoch-to-local-date
const dateFromUtcSeconds = (nbSeconds: number): Date => {
    const d = new Date(0); // The 0 there is the key, which sets the date to the epoch
    d.setUTCSeconds(nbSeconds);
    return d;
}

export default dateFromUtcSeconds;